import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Helmet } from 'react-helmet-async'
import { Waitlist } from '@/components/landing/Waitlist'

export const Route = createFileRoute('/waitlist')({
  validateSearch: z.object({
    ref: z.string().optional(),
  }),
  component: WaitlistPage,
})

function WaitlistPage() {
  return (
    <>
      <Helmet>
        <title>Join the Waitlist — Genie</title>
        <meta
          name="description"
          content="Be among the first to experience the creative intelligent canvas. Join the Genie waitlist."
        />
      </Helmet>
      <main className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-6">
        <Waitlist />
      </main>
    </>
  )
}
